import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Introduction from "./Introduction";
import Services from "./Services";
import Covers from "./Covers";
import Links from "./Links";
import Questions from "./Questions";
import Survey from "./Survey";
import AppDownload from "./AppDownload";
import Footer from "../shares/Footer";
import Banner from "./Banner";
import DaramTakmili from "./DaramTakmili";

// Others File

const Homepage = () => {
  let windowWidth = window.screen.width;
  return (
    <>
      <div className={windowWidth > 768 ? "hp-section-one-img" : ""}>
        <div className="hp-section-one">
          <Navbar activePage="homepage" />
          <Introduction />
        </div>
        <Banner/>
        <DaramTakmili/>
        <Services />
      </div>
      <Covers />
      <Links />
      <Questions />
      <Survey />
      <AppDownload />
      <Footer />
    </>
  );
};
export default Homepage;
